import { render, staticRenderFns } from "./MarketplaceProductsTable.vue?vue&type=template&id=1fcfc9c3&scoped=true"
import script from "./MarketplaceProductsTable.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsTable.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProductsTable.vue?vue&type=style&index=0&id=1fcfc9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcfc9c3",
  null
  
)

export default component.exports